export const OUTGOING_REBUZZ_OPTIONS = {
  CONTENT: 'content',
  PROMOTION: 'promotion',
  ENDORSEMENT: 'endorsement',
};
